import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import GreenButton from '../Shared/GreenButton';
import { useTranslation } from 'react-i18next';
import OrderStartEndDateComponent from './OrderStartEndDateComponent';

export default function EditOrderComponent(props) {
    const classes = useStyles();

    const { t } = useTranslation();

    return (
        <React.Fragment>
        <div className={classes.tableContainer}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    {props.orderInfo.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {t(row.name)}
                            </TableCell>
                            <TableCell className={classes.infoCell}>{row.info}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
        <OrderStartEndDateComponent start = {props.start} end = {props.end} handleFromDateChange = {props.handleFromDateChange} handleTillDateChange = {props.handleTillDateChange}></OrderStartEndDateComponent>         
     <div className={classes.saveButton}>
         <GreenButton text={"SAVE"} onClick={() => props.saveOrder()} disabled={new Date(props.start) > new Date(props.end)}></GreenButton>
     </div>
     </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    row: {
        '&:nth-of-type(even)': {
            backgroundColor: "#F4F4F4",
        },
    },
    tableContainer: {
        marginTop: "20px",
        marginBottom: "20px",
        backgroundColor: "white"
    },
    saveButton: {
        width: "95%",
        textAlign: "center",
        marginTop: "30px",
        marginRight: "5%",
    },
   

}));